module.exports = __webpack_public_path__ + "static/media/Stellar Single Hydraulic Bed Base - 120x200 cm_Light Beige.be65aa75.png";